import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import './Effects.css';
import { useAudio } from '../utils/AudioContext'; // 4. Import Audio Hook
import { playCoinRainSound } from '../utils/sounds'; // 5. Import Sound Function

export const RainingCoins = ({ count = 100 }) => {
    const [particles, setParticles] = useState([]);
    const { sfxMuted } = useAudio(); // 6. Get muted state

    useEffect(() => {
        // 7. Play sound on mount
        playCoinRainSound(sfxMuted);

        const newParticles = Array.from({ length: count }).map((_, i) => ({
            id: i,
            left: Math.random() * 100, // 0 to 100vw
            delay: Math.random() * 1.5, 
            duration: 0.8 + Math.random() * 1.2, 
            scale: 0.5 + Math.random() * 0.8
        }));
        setParticles(newParticles);
    }, [count]); // Intentionally not adding sfxMuted to dependency to avoid re-triggering if user toggles mute during rain

    return createPortal(
        <div className="raining-coins-container">
            {particles.map(p => (
                <div 
                    key={p.id}
                    className="coin-particle"
                    style={{
                        left: `${p.left}%`,
                        animationDuration: `${p.duration}s`,
                        animationDelay: `${p.delay}s`,
                        transform: `scale(${p.scale})`
                    }}
                />
            ))}
        </div>,
        document.body
    );
};

// Updated ConfettiBurst to support specific coordinates
export const ConfettiBurst = ({ x, y, count = 30, colors = ['#ff0000', '#00ff00', '#0000ff', '#ffff00', '#ff00ff', '#00ffff', '#ffffff'] }) => {
    const [particles, setParticles] = useState([]);

    useEffect(() => {
        const newParticles = Array.from({ length: count }).map((_, i) => {
            const angle = Math.random() * 360;
            // Reduced velocity for a tighter "button pop" feel
            const velocity = 50 + Math.random() * 100; 
            const tx = Math.cos(angle * Math.PI / 180) * velocity;
            const ty = Math.sin(angle * Math.PI / 180) * velocity;
            return {
                id: i,
                tx,
                ty,
                color: colors[Math.floor(Math.random() * colors.length)],
                delay: Math.random() * 0.1,
                scale: 0.4 + Math.random() * 0.4 // Slightly smaller particles
            };
        });
        setParticles(newParticles);
    }, [count, colors]);

    // If x/y are provided, position there. Otherwise default to center (though we won't use center anymore).
    const style = (x !== undefined && y !== undefined) 
        ? { top: y, left: x, position: 'fixed', width: 0, height: 0, pointerEvents: 'none', zIndex: 99999 }
        : { top: '50%', left: '50%', position: 'fixed', width: 0, height: 0, pointerEvents: 'none', zIndex: 99999 };

    return createPortal(
        <div style={style}>
            {particles.map(p => (
                <div 
                    key={p.id}
                    className="confetti-particle"
                    style={{
                        '--tx': `${p.tx}px`,
                        '--ty': `${p.ty}px`,
                        '--c-color': p.color,
                        '--s': p.scale,
                        animationDelay: `${p.delay}s`
                    }}
                />
            ))}
        </div>,
        document.body
    );
};